import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { BtnAlmacenar, BtnActualizar , BtnModificar} from "componentes/templates/btn_crud";
import {
  DefaultSelectHorizontal
} from "componentes/templates/input";
import { Cargando, CargandoSmall } from "componentes/templates/cargando";
import {
  BtnBuscar,
  BtnAnterior,
  BtnSiguiente,
  BtnEliminar,
  MenuCantidad,
} from "componentes/templates/btn_crud";
import ModalContainer from "componentes/templates/modalcontainer";
import { GET } from 'helpers/request';
import { POST, PUT, DELETE } from 'helpers/request'
import LanguageHelper from 'helpers/language_helper'


export default function FormSubcategories() {

  const [minispiner, setMinispiner] = useState(true)
  const [cargandoSub, setCargandoSub] = useState(false);

  const [disabledName, setDisabledName] = useState(false);
  let { id } = useParams();
  // Luego de almacenar, debemos regresar a la pantalla anterior con navlink o history
  let history = useHistory();

  /* Arreglo con las variables para colocar los datos en el formulario */
  const variables = [
    "ind_txt_code",
    "ind_txt_name",
    "ind_txt_description",
    "sth_int_id",
    "the_int_id",
    "uni_int_id",
    "cat_int_id_1",
    "cat_int_id_2",
    "cat_int_id_3",
    "cat_int_id_4",
    "cat_int_id_5",
    "ind_txt_goal",
    "ind_txt_observation",
    "ind_txt_measurement_methodology",
    "ind_txt_url_report",
    "ind_sts_display_in",
    "ind_int_order",
    "ind_sts_register",
    "tra_txt_language",
    "tra_txt_table",
    "tra_txt_column",
    "tra_int_idrecord",
    "tra_sts_register",
    "tra_txt_translation",
    "ind_txt_url_report_en",
    "ind_txt_url_report_pt",



  ];



  const [cargando, setCargando] = useState(true);


  const [listado, setListado] = useState(false);
  const [actualizar, setActualizar] = useState(false);
  const [listadoSub, setListadoSub] = useState(false);
  const [listadoUnits, setListadoUnits] = useState(false);
  const [listadoCategorieOne, setListadoCategorieOne] = useState(false);
  const [listadoCategorieTwo, setListadoCategorieTwo] = useState(false);
  const [listadoCategorieThree, setListadoCategorieThree] = useState(false);
  const [listadoCategorieFour, setListadoCategorieFour] = useState(false);
  const [listadoCategorieFive, setListadoCategorieFive] = useState(false);
  const [listadoSourceIndicators, setListadoSourceIndicators] = useState(false);
  const [page, setPage] = useState(0);
  const [cantidad, setCantidad] = useState(5);
  const [key, setKeywords] = useState("");
  const [total, setTotal] = useState(0);
  const [urlSou, setUrlSou] = useState(
    `indicators/getSourcesByIndicator/${id}?l=${cantidad}&o=${page}&k=${key}`
  );
  const [listadoNotesIndicators, setListadoNotesIndicators] = useState(false);
  const [pageNot, setPageNot] = useState(0);
  const [cantidadNot, setCantidadNot] = useState(5);
  const [keyNot, setKeywordsNot] = useState("");
  const [totalNot, setTotalNot] = useState(0);
  const [urlNot, setUrlNot] = useState(
    `indicators/getNotesByIndicator/${id}?l=${cantidadNot}&o=${pageNot}&k=${keyNot}`
  );

  const [listadoTranslations, setListadoTranslations] = useState(false);
  const [pageTra, setPageTra] = useState(0);
  const [cantidadTra, setCantidadTra] = useState(5);
  const [keyTra, setKeywordsTra] = useState("");
  const [totalTra, setTotalTra] = useState(0);
  const [urlTra, setUrlTra] = useState(
    `indicators/getTranslationsByIndicator/${id}?l=${cantidadTra}&o=${pageTra}&k=${keyTra}`
  );


  const gestionarCambioTematicas = async (event) => {

    setCargandoSub(true);
    let idTh = event.target.value;
    const fetcher = async () => {
      const list = await GET(`indicators/subthematicsByThematic/${idTh}`);
      list.error ? console.log("error useEffect ", list.error) : prepararListadoSubtematicas(list);

    };
    fetcher();

    setActualizar(false);


  };


  const gestionarCambio = (event) => {
    if (event.target.type === "radio") {
      localStorage.setItem(event.target.name, event.target.value);
    } else {
      localStorage.setItem(event.target.id, event.target.value);

    }
  };

  const actualizarElemento = async (e) => {
    e.preventDefault();

    try {
      const data = await PUT(variables, "indicators/indicators", id);
      // console.log(res);
      Verificar(data);

    } catch (error) {
      console.log("error", error)
    }

  };


  const Verificar = (result) => {
    let resultado = result;
    if (resultado.status === 201) {
      alert(resultado.messages);
      // limpiar el storage
      variables.forEach(function (valor) {
        localStorage.removeItem(valor);
      });
      history.push("/intranetIndicators/indicatorsList/" + resultado.id);
      window.location.reload();
    } else {
      // regresó error (normalmente 400), no pasó la validación
      variables.forEach(function (valor) {
        // es el mensaje de error q devuelve la validacion del codeigniter
        if (document.getElementById(valor + "_msj") !== null) {
          let mensaje = resultado[valor];
          document.getElementById(valor + "_msj").classList.remove("is-hidden");
          document.getElementById(valor + "_msj").textContent = mensaje;
        }

      });
    }
  };


  const colocar = (result) => {
    let resultado = result;
    //console.log("Variables %c"+variables,"color:green")

    variables.forEach(function (i) {
      switch (i) {
        case "ind_sts_display_in":
          localStorage.setItem(i, resultado[i]);
          if (resultado.ind_sts_display_in === "R")
            document.getElementById("ind_sts_display_in_0").defaultChecked =
              "checked";
          else
            document.getElementById("ind_sts_display_in_1").defaultChecked =
              "checked";
          setMinispiner(false);
          setCargando(false);
          break
        case "ind_sts_register":
          break



        default:
          if (i !== "tra_txt_language" && i !== "tra_txt_translation" && document.getElementById(i) != null) {
            document.getElementById(i).value = resultado[i];
          }
          if (i !== "tra_txt_language" && i !== "tra_txt_translation") {
            localStorage.setItem(i, resultado[i]);
          }
          setMinispiner(false);
          setCargando(false);
          break
      }
    });

  };

  const colocarTematica = (result) => {
    let resultado = result;
    let idThematica = resultado.the_int_id;
    let idSubThematica = resultado.sth_int_id;
    setCargandoSub(true);

    const fetcher = async () => {
      const list = await GET(`indicators/subthematicsByThematic/${idThematica}`);
      list.error ? console.log("error useEffect ", list.error) : prepararListadoSubtematicas(list);
      if (localStorage.getItem('sth_int_id') != null) {
        if (document.getElementById('sth_int_id') != null) {
          document.getElementById('sth_int_id').value = localStorage.getItem('sth_int_id');
        }
      }
    };
    fetcher();
    setActualizar(false);

    if (idSubThematica != null) {
      localStorage.setItem('sth_int_id', idSubThematica);
    }

  };




  const gAlmacenar = async (e) => {
    e.preventDefault();
    localStorage.setItem("tra_txt_language", sessionStorage.getItem('languageId'));
    localStorage.setItem("tra_txt_table", "aro.aro_indicators");
    localStorage.setItem("tra_txt_column", "ind_txt_name");

    try {
      const data = await POST(variables, "indicators/indicators");
      // console.log(res);
      Verificar(data);

    } catch (error) {
      console.log("error", error)
    }

  };

  const prepararListado = (result) => {
    var resultados = result;

    var indicators = resultados.datos;

    const listaItems = () => {
      return (

        <DefaultSelectHorizontal
          label={LanguageHelper.getLanguageString('IndicatorsForm.thematic')}
          inputName="the_int_id"
          onChange={gestionarCambioTematicas}
          options={indicators}
        />


      );
    };
    setCargando(false);
    setListado(listaItems);
  };

  const prepararListadoSubtematicas = (result) => {
    var resultados = result;

    var indicators = resultados.datos;

    const listaItemsSub = () => {

      return (

        <DefaultSelectHorizontal
          label={LanguageHelper.getLanguageString('IndicatorsForm.subthematic')}
          inputName="sth_int_id"
          onChange={gestionarCambio}
          options={indicators}
          required
          idMessage="sth_int_id_msj"
        />


      );
    };


    setListadoSub(listaItemsSub);
    setCargandoSub(false);
    setCargando(false);
  };

  const prepararListadoUnits = (result) => {
    var resultados = result;

    var indicators = resultados.datos;

    const listaItems = () => {
      return (

        <DefaultSelectHorizontal
          label={LanguageHelper.getLanguageString('IndicatorsForm.unit')}
          inputName="uni_int_id"
          onChange={gestionarCambio}
          options={indicators}
        />


      );
    };
    setCargando(false);
    setListadoUnits(listaItems);
  };

  const prepararListadoCategories = (result) => {
    var resultados = result;

    var indicators = resultados.datos;

    const listaItems = () => {
      return (

        <DefaultSelectHorizontal
          label={LanguageHelper.getLanguageString('IndicatorsForm.categoryone')}
          inputName="cat_int_id_1"
          onChange={gestionarCambio}
          options={indicators}
        />


      );
    };
    setCargando(false);
    setListadoCategorieOne(listaItems);

    const listaItemsTwo = () => {
      return (

        <DefaultSelectHorizontal
          label={LanguageHelper.getLanguageString('IndicatorsForm.categorytwo')}
          inputName="cat_int_id_2"
          onChange={gestionarCambio}
          options={indicators}
        />


      );
    };
    setCargando(false);
    setListadoCategorieTwo(listaItemsTwo);

    const listaItemsThree = () => {
      return (

        <DefaultSelectHorizontal
          label={LanguageHelper.getLanguageString('IndicatorsForm.categorythree')}
          inputName="cat_int_id_3"
          onChange={gestionarCambio}
          options={indicators}
        />


      );
    };
    setCargando(false);
    setListadoCategorieThree(listaItemsThree);

    const listaItemsFour = () => {
      return (

        <DefaultSelectHorizontal
          label={LanguageHelper.getLanguageString('IndicatorsForm.categoryfour')}
          inputName="cat_int_id_4"
          onChange={gestionarCambio}
          options={indicators}
        />


      );
    };
    setCargando(false);
    setListadoCategorieFour(listaItemsFour);

    const listaItemsFive = () => {
      return (

        <DefaultSelectHorizontal
          label={LanguageHelper.getLanguageString('IndicatorsForm.categoryfive')}
          inputName="cat_int_id_5"
          onChange={gestionarCambio}
          options={indicators}
        />


      );
    };
    setCargando(false);
    setListadoCategorieFive(listaItemsFive);
  };

  const prepararListadoSources = (result) => {
    var resultados = result;

    var sources = resultados.datos;
    setTotal(resultados.total);

    const gestionarEliminar = async (id) => {
      try {
        await DELETE("indicators/sourcesIndicators/", id);
        // console.log(res);
        setActualizar(true);

      } catch (error) {
        console.log("error ELIMINAR", error)
      }


    };

    const listaItems = sources.map((item) => {
      return (
        <tr key={"sin_" + item.sin_int_id}>
          <td>{item.sou_txt_name}</td>

          <td>
            <BtnEliminar gestionarEliminar={() => gestionarEliminar(item.sin_int_id)} />
          </td>
        </tr>
      );
    });
    setCargando(false);
    setListadoSourceIndicators(listaItems);
  };

  const prepararListadoNotes = (result) => {
    var resultados = result;

    var notes = resultados.datos;
    setTotalNot(resultados.total);

    const gestionarEliminar = async (id) => {

      try {
        await DELETE("indicators/notes/", id);
        // console.log(res);
        setActualizar(true);

      } catch (error) {
        console.log("error ELIMINAR", error)
      }


    };

    const listaItems = notes.map((item) => {
      return (
        <tr key={"not_" + item.not_int_id}>
          <td>{item.not_txt_name}</td>

          <td>
            <BtnEliminar gestionarEliminar={() => gestionarEliminar(item.not_int_id)} />
          </td>
        </tr>
      );
    });
    setCargando(false);
    setListadoNotesIndicators(listaItems);
  };

  const gestionarAnterior = () => {
    let desde = (page - 1) * cantidad;
    if (desde >= 0) {
      setPage(page - 1);
      setUrlSou(
        `indicators/getSourcesByIndicator/${id}?l=${cantidad}&o=${desde}&k=${key}`
      );
    }
  };

  const gestionarCantidad = (event) => {
    event.preventDefault();
    setCantidad(event.target.value);
    setUrlSou(
      `indicators/getSourcesByIndicator/${id}?l=${event.target.value}&o=${page}&k=${key}`
    );
  };


  const gestionarSiguiente = () => {
    let desde = (page + 1) * cantidad;
    if (desde < total) {
      setPage(page + 1);
      setUrlSou(
        `indicators/getSourcesByIndicator/${id}?l=${cantidad}&o=${desde}&k=${key}`
      );
    }
  };

  const gestionarBuscar = (event) => {
    event.preventDefault();
    setPage(0);
    setUrlSou(
      `indicators/getSourcesByIndicator/${id}?l=${cantidad}&o=${page}&k=${key}`
    );
  };

  const obtenerFiltro = (event) => {
    setKeywords(event.target.value);
  };

  const gestionarAnteriorNotes = () => {
    let desde = (pageNot - 1) * cantidadNot;
    if (desde >= 0) {
      setPageNot(pageNot - 1);
      setUrlNot(
        `indicators/getNotesByIndicator/${id}?l=${cantidadNot}&o=${desde}&k=${keyNot}`
      );
    }
  };

  const gestionarCantidadNotes = (event) => {
    event.preventDefault();
    setCantidadNot(event.target.value);
    setUrlNot(
      `indicators/getNotesByIndicator/${id}?l=${event.target.value}&o=${pageNot}&k=${keyNot}`
    );
  };


  const gestionarSiguienteNotes = () => {
    let desde = (pageNot + 1) * cantidadNot;
    if (desde < totalNot) {
      setPageNot(pageNot + 1);
      setUrlNot(
        `indicators/getNotesByIndicator/${id}?l=${cantidadNot}&o=${desde}&k=${keyNot}`
      );
    }
  };

  const gestionarBuscarNotes = (event) => {
    event.preventDefault();
    setPageNot(0);
    setUrlNot(
      `indicators/getNotesByIndicator/${id}?l=${cantidadNot}&o=${pageNot}&k=${keyNot}`
    );
  };

  const obtenerFiltroNotes = (event) => {
    setKeywordsNot(event.target.value);
  };

  const prepararTranslations = (result) => {
    var resultados = result;

    var notes = resultados.datos;
    setTotalTra(resultados.total);

    const gestionarEliminar = async (id) => {

      try {
        await DELETE("indicators/translations/", id);
        // console.log(res);
        setActualizar(true);

      } catch (error) {
        console.log("error ELIMINAR", error)
      }


    };

    const listaItems = notes.map((item) => {
      return (
        <tr key={"tra_" + item.tra_int_id}>
          <td>{item.tra_txt_translation}</td>
          <td>{item.tra_txt_language}</td>

          <td>
            <BtnModificar className="is-spaced" id={item.tra_int_id} nameE={"intranetIndicators/translationsList"} />
            <BtnEliminar gestionarEliminar={() => gestionarEliminar(item.tra_int_id)} />
          </td>
        </tr>
      );
    });

    setListadoTranslations(listaItems);
  };

  const gestionarAnteriorTra = () => {
    let desde = (pageTra - 1) * cantidadTra;
    if (desde >= 0) {
      setPageTra(pageTra - 1);
      setUrlTra(
        `indicators/getTranslationsByThematic/${id}?l=${cantidadTra}&o=${desde}&k=${keyTra}`
      );
    }
  };

  const gestionarCantidadTra = (event) => {
    event.preventDefault();
    setCantidadTra(event.target.value);
    setUrlTra(
      `indicators/getTranslationsByThematic/${id}?l=${event.target.value}&o=${pageTra}&k=${keyTra}`
    );
  };


  const gestionarSiguienteTra = () => {
    let desde = (pageTra + 1) * cantidadTra;
    if (desde < totalTra) {
      setPageTra(pageTra + 1);
      setUrlTra(
        `indicators/getTranslationsByThematic/${id}?l=${cantidadTra}&o=${desde}&k=${keyTra}`
      );
    }
  };

  const gestionarBuscarTra = (event) => {
    event.preventDefault();
    setPageTra(0);
    setUrlTra(
      `indicators/getTranslationsByThematic/${id}?l=${cantidadTra}&o=${pageTra}&k=${keyTra}`
    );
  };

  const obtenerFiltroTra = (event) => {
    setKeywordsTra(event.target.value);
  };

  useEffect(() => {

    let urlU = `indicators/optionThematics`;

    const fetcherI = async () => {
      const list = await GET(urlU);
      list.error ? console.log("error useEffect ", list.error) : prepararListado(list);

    };
    fetcherI();


    let urlUni = `indicators/optionUnits`;

    const fetcherU = async () => {
      const list = await GET(urlUni);
      list.error ? console.log("error useEffect ", list.error) : prepararListadoUnits(list);

    };
    fetcherU();

    let urlCat = `indicators/optionCategories`;
    const fetcherCat = async () => {
      const list = await GET(urlCat);
      list.error ? console.log("error useEffect ", list.error) : prepararListadoCategories(list);

    };
    fetcherCat();

    setActualizar(false);

    if (id !== "0") {

      let urlTh = `indicators/indicators/${id}`;
      const fetcherTh = async () => {
        const list = await GET(urlTh);
        list.error ? console.log("error useEffect ", list.error) : colocarTematica(list);

      };
      fetcherTh();

      const fetcherSou = async () => {
        const list = await GET(urlSou);
        list.error ? console.log("error useEffect ", list.error) : prepararListadoSources(list);

      };
      fetcherSou();

      const fetcherNot = async () => {
        const list = await GET(urlNot);
        list.error ? console.log("error useEffect ", list.error) : prepararListadoNotes(list);

      };
      fetcherNot();

      let url = `indicators/indicators/${id}`;
      const fetcherInd = async () => {
        const list = await GET(url);
        list.error ? console.log("error useEffect ", list.error) : colocar(list);

      };
      fetcherInd();

      const fetcherTra = async () => {
        const list = await GET(urlTra);
        list.error ? console.log("error useEffect ", list.error) : prepararTranslations(list);

      };
      fetcherTra();
      setDisabledName(true);




    } else {


      variables.forEach(function (valor) {
        localStorage.removeItem(valor);
      });

      let urlThem = `indicators/subthematicsByThematic/0`;
      const fetcherSub = async () => {
        const list = await GET(urlThem);
        list.error ? console.log("error useEffect ", list.error) : prepararListadoSubtematicas(list);

      };
      fetcherSub();

      setActualizar(false);
      setMinispiner(false)

    }

    return () => {
      setCargando(true);

    };
    // eslint-disable-next-line
  }, [urlSou, actualizar, urlNot])

  if (cargando) return <Cargando />;
  else
    return (
      <div className="container is-fluid">
        <div className="columns">
          <div className="column is-9 is-offset-1">
            <h3 className="title is-3">
              {id === "0" ? LanguageHelper.getLanguageString('IndicatorsForm.Title.add') : LanguageHelper.getLanguageString('IndicatorsForm.Title.upd')}
            </h3>

            <form autoComplete="nope">

              <div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.code')}:</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <p className="control has-icons-left">
                      <input
                        type="text"
                        placeholder={LanguageHelper.getLanguageString('IndicatorsForm.code')}
                        className="input"
                        id="ind_txt_code"
                        required
                        onChange={gestionarCambio}
                      />
                      <span className="icon is-small is-left">
                        <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              {disabledName ? "" :<div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.name')}:</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <p className="control has-icons-left">
                      <input
                        type="text"
                        placeholder={LanguageHelper.getLanguageString('IndicatorsForm.name')}
                        className="input"
                        id="ind_txt_name"
                        required
                        onChange={gestionarCambio}
                      />
                      <span className="icon is-small is-left">
                        <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                      </span>
                    </p>
                  </div>
                  <p
                    className="is-hidden help is-danger"
                    id="ind_txt_name_msj"
                  ></p>
                </div>
              </div>}

              <div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.description')}:</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <p className="control has-icons-left">
                      <textarea

                        placeholder={LanguageHelper.getLanguageString('IndicatorsForm.description')}
                        className="textarea"
                        id="ind_txt_description"
                        required
                        onChange={gestionarCambio}
                      />

                    </p>
                  </div>
                </div>
              </div>

              <div className="field">
                {listado}
              </div>


              {(cargandoSub) ? (<CargandoSmall />) : (<div className="field">
                {listadoSub}
              </div>)}

              <div className="field">
                {listadoUnits}
              </div>

              <div className="field">
                {listadoCategorieOne}
              </div>

              <div className="field">
                {listadoCategorieTwo}
              </div>

              <div className="field">
                {listadoCategorieThree}
              </div>

              <div className="field">
                {listadoCategorieFour}
              </div>

              <div className="field">
                {listadoCategorieFive}
              </div>

              <div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.goal')}:</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <p className="control has-icons-left">
                      <textarea

                        placeholder={LanguageHelper.getLanguageString('IndicatorsForm.goal')}
                        className="textarea"
                        id="ind_txt_goal"
                        required
                        onChange={gestionarCambio}
                      />

                    </p>
                  </div>
                </div>
              </div>

              <div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.obseravation')}:</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <p className="control has-icons-left">
                      <textarea

                        placeholder={LanguageHelper.getLanguageString('IndicatorsForm.obseravation')}
                        className="textarea"
                        id="ind_txt_observation"
                        required
                        onChange={gestionarCambio}
                      />

                    </p>
                  </div>
                </div>
              </div>

              <div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.metodology')}:</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <p className="control has-icons-left">
                      <textarea

                        placeholder={LanguageHelper.getLanguageString('IndicatorsForm.metodology')}
                        className="textarea"
                        id="ind_txt_measurement_methodology"
                        required
                        onChange={gestionarCambio}
                      />

                    </p>
                  </div>
                </div>
              </div>

              <div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.url')}:</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <p className="control has-icons-left">
                      <input
                        type="text"
                        placeholder={LanguageHelper.getLanguageString('IndicatorsForm.url')}
                        className="input"
                        id="ind_txt_url_report"
                        required
                        onChange={gestionarCambio}
                        maxLength="512"
                      />
                      <span className="icon is-small is-left">
                        <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.urlEn')}:</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <p className="control has-icons-left">
                      <input
                        type="text"
                        placeholder={LanguageHelper.getLanguageString('IndicatorsForm.urlEn')}
                        className="input"
                        id="ind_txt_url_report_en"
                        required
                        onChange={gestionarCambio}
                        maxLength="512"
                      />
                      <span className="icon is-small is-left">
                        <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.urlPt')}:</label>
                </div>
                <div className="field-body">
                  <div className="field">
                    <p className="control has-icons-left">
                      <input
                        type="text"
                        placeholder={LanguageHelper.getLanguageString('IndicatorsForm.urlPt')}
                        className="input"
                        id="ind_txt_url_report_pt"
                        required
                        onChange={gestionarCambio}
                        maxLength="512"
                      />
                      <span className="icon is-small is-left">
                        <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.presentation')}:</label>
                </div>
                <div className="field-body">
                  <div className="field is-narrow">
                    <div className="control">
                      <label className="radio">
                        <input
                          type="radio"
                          value="R"
                          id="ind_sts_display_in_0"
                          name="ind_sts_display_in"
                          onChange={gestionarCambio}
                        />
                        {LanguageHelper.getLanguageString('IndicatorsForm.report')}
                      </label>
                      <label className="radio">
                        <input
                          type="radio"
                          value="I"
                          id="ind_sts_display_in_1"
                          name="ind_sts_display_in"
                          onChange={gestionarCambio}
                        />
                        {LanguageHelper.getLanguageString('IndicatorsForm.indicator')}
                      </label>
                    </div>
                  </div>
                  <p
                    className="is-hidden help is-danger"
                    id="ind_sts_display_in_msj"
                  ></p>
                </div>

              </div>

              <div className="field is-horizontal">
                <div className="field-label">
                  <label className="label">{LanguageHelper.getLanguageString('IndicatorsForm.order')}:</label>
                </div>
                <div className="field-body">
                  <div className="control has-icons-left">
                    <input
                      type="number"
                      placeholder={LanguageHelper.getLanguageString('IndicatorsForm.order')}
                      className="input"
                      id="ind_int_order"
                      required
                      onChange={gestionarCambio}
                      min="1"
                    />
                    <span className="icon is-small is-left">
                      <i className={(minispiner) ? "fa fa-cog fa-spin" : "fas fa-users"}></i>
                    </span>
                  </div>
                  <p
                    className="is-hidden help is-danger"
                    id="ind_int_order_msj"
                  ></p>
                </div>

              </div>

              {id === "0" ? (
                <BtnAlmacenar gAlmacenar={gAlmacenar}>{LanguageHelper.getLanguageString('IndicatorsForm.save')}</BtnAlmacenar>
              ) : (
                  <BtnActualizar actualizarElemento={actualizarElemento}>
                    {LanguageHelper.getLanguageString('IndicatorsForm.update')}
                  </BtnActualizar>
                )}
            </form>


          </div>


        </div>
        {
          id !== "0" ? (
            <>
              <div className="message is-success">
                <div className="column is-9 is-offset-1">
                  <div className="field">
                    <div className="message-header">
                      <p>{LanguageHelper.getLanguageString('TranslationIndicators.Title')}</p>
                    </div>

                  </div>
                  <div className="columns">
                    <div className="column is-9 is-offset-1">
                      <form onSubmit={gestionarBuscarTra}>
                        <div className="field has-addons">
                          <div className="control has-icons-left has-icons-right">
                            <input
                              className="input"
                              type="text"
                              name="k"
                              id="k"
                              placeholder={LanguageHelper.getLanguageString('TranslationThematics.placeholder')}
                              onChange={obtenerFiltroTra}
                            />
                            <span className="icon is-small is-left">
                              <i className="fas fa-key"></i>
                            </span>
                          </div>
                          <div className="control">
                            <BtnBuscar />
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="column is-2">
                      <ModalContainer modalTitle={LanguageHelper.getLanguageString('TranslationForm.add')} info_component="tra" ind_int_id={id} save={null} labelClose={LanguageHelper.getLanguageString('TranslationForm.close')} tableT="aro.aro_indicators" />
                    </div>

                  </div>

                  <div className="columns">
                    <div className="column is-10 is-offset-1">
                      <div className="table-container">
                        <table className="table is-striped is-bordered is-hoverable is-fullwidth">
                          <thead>
                            <tr>


                              <th>{LanguageHelper.getLanguageString('TranslationThematics.translation')}</th>
                              <th>{LanguageHelper.getLanguageString('TranslationThematics.language')}</th>
                              <th>{LanguageHelper.getLanguageString('TranslationThematics.options')}</th>
                            </tr>
                          </thead>
                          <tbody>{listadoTranslations}</tbody>
                          <tfoot>
                            <tr>
                              <td colSpan="1" className="has-text-centered">
                                {pageTra > 0 ? (
                                  <BtnAnterior gestionarAnterior={gestionarAnteriorTra} />
                                ) : (
                                    <BtnAnterior gestionarAnterior={null} />
                                  )}

                                <MenuCantidad
                                  className=""
                                  gestionarCantidad={gestionarCantidadTra}
                                  total={totalTra}
                                  can={cantidadTra}
                                />

                                {(pageTra + 1) * cantidadTra < totalTra ? (
                                  <BtnSiguiente gestionarSiguiente={gestionarSiguienteTra} />
                                ) : (
                                    <BtnSiguiente gestionarSiguiente={null} />
                                  )}
                              </td>
                              <td>{LanguageHelper.getLanguageString('TranslationThematics.total')}: {totalTra}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="message is-success">
                <div className="column is-9 is-offset-1">
                  <div className="field">
                    <div className="message-header">
                      <p>{LanguageHelper.getLanguageString('IndicatorsSources.title')}</p>
                    </div>

                  </div>
                  <div className="columns">
                    <div className="column is-9 is-offset-1">
                      <form onSubmit={gestionarBuscar}>
                        <div className="field has-addons">
                          <div className="control has-icons-left has-icons-right">
                            <input
                              className="input"
                              type="text"
                              name="k"
                              id="k"
                              placeholder={LanguageHelper.getLanguageString('IndicatorsSources.addTexto')}
                              onChange={obtenerFiltro}
                            />
                            <span className="icon is-small is-left">
                              <i className="fas fa-key"></i>
                            </span>
                          </div>
                          <div className="control">
                            <BtnBuscar />
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="column is-2">
                      <ModalContainer modalTitle={LanguageHelper.getLanguageString('IndicatorsSources.add')} info_component="sou" ind_int_id={id} save={null} labelClose={LanguageHelper.getLanguageString('IndicatorsSources.close')} />
                    </div>
                  </div>

                  <div className="columns">
                    <div className="column is-10 is-offset-1">
                      <div className="table-container">
                        <table className="table is-striped is-bordered is-hoverable is-fullwidth">
                          <thead>
                            <tr>


                              <th>{LanguageHelper.getLanguageString('IndicatorsSources.name')}</th>
                              <th>{LanguageHelper.getLanguageString('IndicatorsSources.options')}</th>
                            </tr>
                          </thead>
                          <tbody>{listadoSourceIndicators}</tbody>
                          <tfoot>
                            <tr>
                              <td colSpan="1" className="has-text-centered">
                                {page > 0 ? (
                                  <BtnAnterior gestionarAnterior={gestionarAnterior} />
                                ) : (
                                    <BtnAnterior gestionarAnterior={null} />
                                  )}

                                <MenuCantidad
                                  className=""
                                  gestionarCantidad={gestionarCantidad}
                                  total={total}
                                  can={cantidad}
                                />

                                {(page + 1) * cantidad < total ? (
                                  <BtnSiguiente gestionarSiguiente={gestionarSiguiente} />
                                ) : (
                                    <BtnSiguiente gestionarSiguiente={null} />
                                  )}
                              </td>
                              <td>{LanguageHelper.getLanguageString('IndicatorsSources.total')}: {total}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="message is-success">
                <div className="column is-9 is-offset-1">
                  <div className="field">
                    <div className="message-header">
                      <p>{LanguageHelper.getLanguageString('IndicatorsNotes.title')}</p>
                    </div>

                  </div>
                  <div className="columns">
                    <div className="column is-9 is-offset-1">
                      <form onSubmit={gestionarBuscarNotes}>
                        <div className="field has-addons">
                          <div className="control has-icons-left has-icons-right">
                            <input
                              className="input"
                              type="text"
                              name="k"
                              id="k"
                              placeholder={LanguageHelper.getLanguageString('IndicatorsNotes.addTexto')}
                              onChange={obtenerFiltroNotes}
                            />
                            <span className="icon is-small is-left">
                              <i className="fas fa-key"></i>
                            </span>
                          </div>
                          <div className="control">
                            <BtnBuscar />
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="column is-2">
                      <ModalContainer modalTitle={LanguageHelper.getLanguageString('IndicatorsNotes.add')} info_component="not" ind_int_id={id} save={null} labelClose={LanguageHelper.getLanguageString('IndicatorsNotes.close')} />
                    </div>
                  </div>

                  <div className="columns">
                    <div className="column is-10 is-offset-1">
                      <div className="table-container">
                        <table className="table is-striped is-bordered is-hoverable is-fullwidth">
                          <thead>
                            <tr>


                              <th>{LanguageHelper.getLanguageString('IndicatorsNotes.name')}</th>
                              <th>{LanguageHelper.getLanguageString('IndicatorsNotes.options')}</th>
                            </tr>
                          </thead>
                          <tbody>{listadoNotesIndicators}</tbody>
                          <tfoot>
                            <tr>
                              <td colSpan="1" className="has-text-centered">
                                {page > 0 ? (
                                  <BtnAnterior gestionarAnterior={gestionarAnteriorNotes} />
                                ) : (
                                    <BtnAnterior gestionarAnterior={null} />
                                  )}

                                <MenuCantidad
                                  className=""
                                  gestionarCantidad={gestionarCantidadNotes}
                                  total={totalNot}
                                  can={cantidadNot}
                                />

                                {(pageNot + 1) * cantidadNot < totalNot ? (
                                  <BtnSiguiente gestionarSiguiente={gestionarSiguienteNotes} />
                                ) : (
                                    <BtnSiguiente gestionarSiguiente={null} />
                                  )}
                              </td>
                              <td>{LanguageHelper.getLanguageString('IndicatorsNotes.total')}: {totalNot}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>

          ) : ('')
        }
      </div>
    );
}
